const styles = theme => ({
  root: {
    padding: 0,
  },
  content: {
    padding: 20,
    width: 475,
  },
  title: {
    fontSize: theme.constants.fontSizes.regular,
    fontWeight: 'bold',
    marginBottom: 15,
  },
  input: {
    marginBottom: 30,
  },
  description: {
    fontSize: theme.constants.fontSizes.regular,
    paddingBottom: 20,
  },
});

export default styles;
